import api from "./api";
import type { Plano } from "../types/plano";

async function findById(
  id: number,
  abortController?: AbortController
): Promise<Plano> {
  return await api
    .get<Plano>(`/api/v2/app/plano/${id}`, {
      signal: abortController?.signal,
    })
    .then((response) => response.data);
}

const planoApi = {
  findById,
};

export default planoApi;
